import { z } from 'zod';

import { baseNotificationRawSchema, baseNotificationRawSchemaParser } from './BaseNotification';

export const otherNotificationType = z.literal('OTHER');

export const otherNotificationSchema = baseNotificationRawSchema
  .extend({
    type: otherNotificationType,
  })
  .transform((raw) => {
    return {
      ...baseNotificationRawSchemaParser(raw),
      type: raw.type,
    };
  });

export type OtherNotificationEntityApi = z.input<typeof otherNotificationSchema>;

export type OtherNotificationEntity = z.infer<typeof otherNotificationSchema>;
